"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var util = _interopRequireWildcard(require("../util"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function length(rule, value, errors, options) {
  var key = null;
  var isNum = typeof value === 'number';
  var isStr = typeof value === 'string';
  var isArr = Array.isArray(value);

  if (isNum) {
    key = 'number';
  } else if (isStr) {
    key = 'string';
  } else if (isArr) {
    key = 'array';
  }

  if (!key) {
    return false;
  }

  var val = value;
  var length = Number(rule.length);
  var maxLength = Number(rule.maxLength);
  var minLength = Number(rule.minLength);

  if (minLength || maxLength || length) {
    if (isNum) {
      val = "".concat(val);
    }

    val = val.length;

    if (length && val !== rule.length) {
      errors.push(util.format(options.messages[key].length, rule.aliasName || rule.field, rule.length));
    } else if (val < minLength) {
      errors.push(util.format(options.messages[key].minLength, rule.aliasName || rule.field, rule.minLength));
    } else if (val > maxLength) {
      errors.push(util.format(options.messages[key].maxLength, rule.aliasName || rule.field, rule.maxLength));
    }
  }
}

var _default = length;
exports.default = _default;